import { useEffect, useState, useRef } from "react";

const UseInView = (options = {}, once = true) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) {
            observer.disconnect(); // stop observing after first intersection
          }
        } else if (!once) {
          setInView(false); // only update if we want repeated triggers
        }
      },
      { threshold: 0.2, ...options }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [options, once]);

  return [ref, inView];
};

export default UseInView;
